import { AbstractControl, ValidatorFn } from '@angular/forms';

export function validRange(min: number, max: number, value: number) {
  return value >= min && value <= max;
}

function validateValue(min: number, max: number, value: number) {
  const valid = validRange(min, max, value);

  return valid ? null : { range: { min, max, value } };
}

export function rangeValidator(min: number, max: number): ValidatorFn {
  return (control: AbstractControl) => {
    try {
      const value = parseFloat(control.value);
      return validateValue(min, max, value);
    } catch (e) {
      return null;
    }
  };
}

export function brlRangeValidator(min: number, max: number): ValidatorFn {
  return (control: AbstractControl) => {
    try {
      const value = parseFloat(control.value.replace(/[^0-9,]/g, '').replace(',', '.'));

      return validateValue(min, max, value);
    } catch (e) {
      return null;
    }
  };
}
